import { grey } from '@material-ui/core/colors';

export default (theme) => ({
  container: { maxHeigh: 700 },
  progress: { margin: theme.spacing(2) },
  progressContainer: { textAlign: 'center' },
  dashboardListContainer: {
    margin: theme.spacing(2),
    padding: theme.spacing(2),
    overflowY: 'auto',
    backgroundColor: grey[100],
  },
  dashboardEditContainer: {
    padding: 0,
    margin: theme.spacing(2),
    overflowY: 'auto',
  },
  noDashboardsDisclaimer: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    marginBottom: theme.spacing(2),
    backgroundColor: grey[100],
  },
  cardActions: { float: 'right' },
});
